var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tw-file-input',{attrs:{"accepted":['application/json'],"read-as":"text"},on:{"read":_vm.onFileRead}},[_c('save',{attrs:{"size":"xs"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }